var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('div',{class:_vm.small? 'avatar-small':'avatar'},[_c('el-image',{attrs:{"src":item.imgUrl,"fit":"cover"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }